import clsx from "clsx";

import { Pill } from "@/components/Interface/Pill/Pill";
import { BillStatus } from "@/utils/enums";

/** Translation key (under `bills.list.status`) and text colour per bill status. */
export const billStatusConfig = {
  [BillStatus.reminder]: {
    translationKey: "reminder",
    textColor: "text-foreground-error",
  },
  [BillStatus.overdue]: {
    translationKey: "due",
    textColor: "text-foreground-warning",
  },
  [BillStatus.closed]: {
    translationKey: "paid",
    textColor: "text-foreground-success",
  },
  [BillStatus.canceled]: {
    translationKey: "canceled",
    textColor: "text-foreground-info",
  },
} as const satisfies Record<
  BillStatus,
  { translationKey: string; textColor: string }
>;

export const isBillStatus = (status?: string): status is BillStatus =>
  (Object.values(BillStatus) as string[]).includes(status ?? "");

export const BillStatusChip = ({
  status,
  label,
}: {
  status?: string;
  label: string;
}) => (
  <Pill
    className={clsx(
      "bg-surface-quaternary",
      isBillStatus(status)
        ? billStatusConfig[status].textColor
        : "text-foreground-primary",
    )}
    size="sm"
    text={label}
  />
);
